import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { MerchantInfo } from 'services/merchants/types';

import { Panel } from 'components/containers';
import IconRefundBalance from 'components/icons/refundBalance';

import { CurrencyCode } from 'types/currency';
import { TablePagination } from 'types/pagination';
import { TableSorting } from 'types/sort';

import { formatFiatCurrencyI18n } from 'utils/i18n';

import { LABELS } from './keys';
import { Balance, Container } from './styles';

interface PayoutReserveProps {
  cryptoPayoutBalances?: MerchantInfo['cryptoPayoutBalances'];
  error?: string;
  isLoading?: boolean;
  pagination?: TablePagination;
  onChangePage?: (page: number) => void;
  onChangeRowsPerPage?: (itemsPerPage: number) => void;
  onSort?: (event: MouseEvent, property: string) => void;
  sorting?: TableSorting;
}

const PayoutReserve = ({
  cryptoPayoutBalances,
  error,
  isLoading,
  pagination,
  onChangePage,
  onChangeRowsPerPage,
  onSort,
  sorting,
}: PayoutReserveProps) => {
  const { t, i18n } = useTranslation();
  const currencyCode = CurrencyCode.USD;

  return (
    <Panel label={t(LABELS.PAGE_TITLE)}>
      <Container>
        <Balance>
          <span>
            <IconRefundBalance />
            {t(LABELS.PAYOUT_RESERVE_BALANCE)}
          </span>
          {formatFiatCurrencyI18n(i18n.language)(Number(cryptoPayoutBalances?.available) ?? 0, currencyCode)}
        </Balance>
      </Container>
    </Panel>
  );
};

export default PayoutReserve;
